/* V27 — mobile menu: backdrop, escape-to-close, animated accordions, focus handling */
(() => {
  const menu = document.querySelector('[data-mobile-menu]');
  if (!menu) return;

  const backdrop = document.querySelector('[data-mobile-menu-backdrop]');
  const closeBtn = menu.querySelector('[data-mobile-menu-close]');
  const openBtns = document.querySelectorAll('[data-mobile-menu-open]');
  const isOpen = () => menu.classList.contains('is-open');

  // Keep the backdrop in sync with the drawer (theme.js toggles .is-open)
  const sync = () => {
    if (backdrop) backdrop.classList.toggle('is-visible', isOpen());
    if (isOpen()) {
      menu.removeAttribute('inert');
    } else {
      // collapse any open accordions when the drawer closes
      menu.querySelectorAll('.mobile-nav-item.is-open').forEach(item => {
        item.classList.remove('is-open');
        item.querySelector('[data-mobile-nav-toggle]')?.setAttribute('aria-expanded', 'false');
      });
    }
  };
  new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
  sync();

  // Move focus into the drawer when it opens; back to the trigger when it closes
  let lastTrigger = null;
  openBtns.forEach(btn => btn.addEventListener('click', () => {
    lastTrigger = btn;
    setTimeout(() => closeBtn?.focus({ preventScroll: true }), 320);
  }));
  menu.querySelectorAll('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', () => {
    setTimeout(() => lastTrigger?.focus({ preventScroll: true }), 50);
  }));

  // Escape closes
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && isOpen()) closeBtn?.click();
  });

  // Swipe left to close
  let touchStartX = null;
  menu.addEventListener('touchstart', e => { touchStartX = e.touches[0].clientX; }, { passive: true });
  menu.addEventListener('touchend', e => {
    if (touchStartX === null) return;
    const dx = e.changedTouches[0].clientX - touchStartX;
    touchStartX = null;
    if (dx < -70 && isOpen()) closeBtn?.click();
  }, { passive: true });

  // Accordions — whole row is the tap target
  menu.querySelectorAll('[data-mobile-nav-toggle]').forEach(btn => {
    btn.addEventListener('click', () => {
      const item = btn.closest('.mobile-nav-item');
      const willOpen = btn.getAttribute('aria-expanded') !== 'true';
      // one open at a time keeps the list calm
      menu.querySelectorAll('.mobile-nav-item.is-open').forEach(other => {
        if (other !== item) {
          other.classList.remove('is-open');
          other.querySelector('[data-mobile-nav-toggle]')?.setAttribute('aria-expanded', 'false');
        }
      });
      btn.setAttribute('aria-expanded', String(willOpen));
      item?.classList.toggle('is-open', willOpen);
      if (willOpen) {
        setTimeout(() => {
          const body = menu.querySelector('.mobile-menu__body');
          const top = item.getBoundingClientRect().top - menu.getBoundingClientRect().top - 72;
          if (body && top > 0) body.scrollBy({ top: Math.min(top, 160), behavior: 'smooth' });
        }, 60);
      }
    });
  });
})();
